import { render, staticRenderFns } from "./appletlistedit.vue?vue&type=template&id=60565cac&"
import script from "./appletlistedit.vue?vue&type=script&lang=js&"
export * from "./appletlistedit.vue?vue&type=script&lang=js&"
import style0 from "./appletlistedit.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports